var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.053 7.61314L4.93297 13.7331C4.41297 14.2531 4.41297 15.0931 4.93297 15.6131C5.45297 16.1331 6.29297 16.1331 6.81297 15.6131L11.9996 10.4398L17.173 15.6131C17.693 16.1331 18.533 16.1331 19.053 15.6131C19.573 15.0931 19.573 14.2531 19.053 13.7331L12.933 7.61314C12.4263 7.09314 11.573 7.09314 11.053 7.61314Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUp);
export default __webpack_public_path__ + "static/media/chevron-up.228238a9ad9bb3d0776b24aad220d3f8.svg";
export { ForwardRef as ReactComponent };